'use client';
import { useFetchPublicFeed, useResetFeedCache } from '@/actions/feed.actions';
import HomeFooter from '@/app/(protected)/components/HomeFooter';
import Post from '@components/Post';
import Spinner from '@components/Spinner';
import Typography from '@ui/Typography';
import { size } from 'lodash-es';
import React, { useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

function Posts(props) {
  const { fetcher, initialPosts, orgSlug } = props;

  const resetFeedCache = useResetFeedCache();
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    refetch,
  } = useFetchPublicFeed(initialPosts, fetcher);

  // derived states
  const totalPostsCached =
    data?.pages.reduce((acc, group) => acc + size(group.posts), 0) || 0;

  const handleLoadNextPage = async () => {
    if (!isFetchingNextPage && hasNextPage) {
      return fetchNextPage();
    }
    return [];
  };

  // TODO: check
  useEffect(() => {
    resetFeedCache();
    // handleLoadNextPage();
    refetch();
  }, []);

  const handleShowFooter = () => {
    if (orgSlug?.includes('nonprofit')) return true;
    return false;
  };

  return (
    <InfiniteScroll
      dataLength={totalPostsCached}
      next={handleLoadNextPage}
      hasMore={hasNextPage || isFetchingNextPage || isLoading}
      loader={
        <div className="relative flex w-full items-center justify-center p-2">
          <Spinner className="h-8 w-8 text-primary" />
        </div>
      }
      endMessage={
        <div className="flex items-center justify-center p-2">
          {/* {handleShowFooter() ? (
            <HomeFooter />
          ) : (
            <Typography variant="body1" color="textDisabled">
              There are no more posts to show right now.
            </Typography>
          )} */}
          <HomeFooter />
        </div>
      }>
      <div className="relative z-0 flex w-full flex-col gap-2.5">
        {data?.pages.map((group, pageIndex) => (
          <React.Fragment key={pageIndex}>
            {group.posts.map((post, postIndex) => (
              <Post
                type="public"
                key={post.id}
                post={post}
                // hack for ensuring comments menu is rendered on top of the next post card
                style={{
                  zIndex: -(pageIndex * group.posts.length + postIndex),
                }}
                orgSlug={orgSlug}
              />
            ))}
          </React.Fragment>
        ))}
      </div>
    </InfiniteScroll>
  );
}

export default Posts;
